import { render, staticRenderFns } from "./BenchmarkDateManagement.vue?vue&type=template&id=63d65bec&scoped=true"
import script from "./BenchmarkDateManagement.vue?vue&type=script&lang=js"
export * from "./BenchmarkDateManagement.vue?vue&type=script&lang=js"
import style0 from "./BenchmarkDateManagement.vue?vue&type=style&index=0&id=63d65bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d65bec",
  null
  
)

export default component.exports